import { Stack } from 'ui/stack';

import Icons from 'assets/icons';

const ErrorWidget = (): React.JSX.Element => (
  <Stack
    sx={{
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
      p: 2.5,
      bgcolor: 'tokens.navy.50',
      borderRadius: '0.5rem',
    }}
  >
    <Icons.Warning customClass="h-7 w-7 mr-2 text-critical-500 mb-2" />
    <p className="text-lg font-semibold">Something went wrong.</p>
    <p>Please try to reload the page.</p>
  </Stack>
);

export default ErrorWidget;
